import React from 'react';
import { withForm } from 'components/common';
import { FormGroup, SaveButton } from 'components/common/Forms';
import { Card, CardBody, Table } from 'reactstrap';
import { compose, withPropsOnChange, branch, renderNothing } from 'recompose';
import { Link } from 'react-router-dom';
import { LocalForm, Control, track } from 'react-redux-form';
import { NotificationManager } from 'react-notifications';
import { orderBy } from 'lodash';

export const RegionPriority = ({
  readOnly,
  onChange,
  onUpdate,
  item,
  form,
  setDispatch,
  dispatch,
  onSubmit,
  onCancel,
}) => (
  <LocalForm
    onSubmit={onSubmit}
    getDispatch={setDispatch}
    onChange={onChange}
    onUpdate={onUpdate}
    initialState={item}
  >
    <Card>
      <CardBody>
        <FormGroup>
          {item &&
            item.installer_priorities &&
            item.installer_priorities.length === 0 && (
              <span>No Installers assigned to {item.name}</span>
            )}
          {item &&
            item.installer_priorities && (
              <Table>
                <thead>
                  <tr>
                    <th>Installer</th>
                    <th>Priority</th>
                  </tr>
                </thead>
                <tbody>
                  {orderBy(
                    item.installer_priorities,
                    ['priority', 'name'],
                    ['desc', 'asc']
                  ).map(i => (
                    <tr key={i.id}>
                      <td>
                        <Link
                          to={`/installers/${i.installer_id}#Region%20Priority`}
                        >
                          {i.name}
                        </Link>
                      </td>
                      <td>
                        <Control.input
                          type="number"
                          style={{ width: '10ex' }}
                          model={track('.installer_priorities[].priority', {
                            id: i.id,
                          })}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
        </FormGroup>
        <SaveButton className="float-right" form={form} hidden={readOnly} />
      </CardBody>
    </Card>
  </LocalForm>
);

const enhance = compose(
  withForm({
    defaultItem: null,
    onSubmit: ({ item, client, regionId, countryId }) => () =>
      client
        .patch(`installer-rules/${countryId}/regions/${regionId}`, item)
        .then(() => {
          NotificationManager.success('Priorities successfully updated');
        }),
  }),
  withPropsOnChange(
    ['regionId', 'countryId'],
    ({ client, setItem, regionId, countryId }) => {
      if (!regionId || !countryId) return;
      return client
        .get(`installer-rules/${countryId}/regions/${regionId}`)
        .then(resp => {
          setItem(resp.data);
        })
        .catch(err => {
          throw err;
        });
    }
  ),
  branch(
    props => !props.item || !props.regionId || !props.countryId,
    renderNothing
  )
);

export default enhance(RegionPriority);



// WEBPACK FOOTER //
// ./src/pages/InstallerRules/RegionPriority.jsx